import * as React from "react";
import AuthContext from "Context/AuthContext";
import { CustomerBolHandler } from "./CustomerBolHandler";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { CustomerBolTable, CustomerBolDetail } from ".";

export interface Props extends RouteComponentProps {
    children?: React.ReactNode
}

export interface State {
    detailedClicked: boolean
}

class CustomerBolOverviewBase extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    constructor(props: Props) {
        super(props)

        this.state = {
            detailedClicked: false,
        }
    }

    componentDidMount() {
        console.log("constext", this.context.data)
    }

    render() {
        return (
            <CustomerBolTable customerCode={this.context.data?.customerCode} />
        )
    }
}

const CustomerBolOverview = withRouter(CustomerBolOverviewBase);

export default CustomerBolOverview;